// eslint-disable-next-line
import AgendamentoMedicoBackofficeApi from './Services/AgendamentoBackofficeApi'
// eslint-disable-next-line import/no-cycle
import SolicitacaoCirurgiaApi from './Services/SolicitacaoCirurgiaApi'
import SolicitacaoPendenciaApi from './Services/SolicitacaoPendenciaApi'
import SolicitacaoComentarioApi from './Services/SolicitacaoComentarioApi'
import SolicitacaoAnotacoesApi from './Services/SolicitacaoAnotacoesApi'
import ContestacaoMedicaApi from './Services/ContestacaoMedicaApi'
import HistoricoSolicitacaoApi from './Services/HistoricoSolicitacaoApi'
import AprovacaoApi from './Services/AprovacaoApi'
import LogoutApi from './Services/LogoutApi'

import SuporteApi from './Services/SuporteApi'
import RecursosHospitalaresApi from './Services/RecursosHospitalaresApi'
import CirurgiaConjuntaApi from './Services/CirurgiaConjuntaApi'


export default {
  SolicitacaoCirurgiaApi,
  AgendamentoMedicoBackofficeApi,
  SolicitacaoPendenciaApi,
  SolicitacaoComentarioApi,
  SolicitacaoAnotacoesApi,
  ContestacaoMedicaApi,
  HistoricoSolicitacaoApi,
  AprovacaoApi,
  SuporteApi,
  LogoutApi,
  RecursosHospitalaresApi,
  CirurgiaConjuntaApi,
}
